import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Crown } from "lucide-react";

export default function Standings() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/standings").then((r) => setItems(r.data)); }, []);

    const east = items.filter((s) => (s.conference || "").toLowerCase().startsWith("e"));
    const west = items.filter((s) => !(s.conference || "").toLowerCase().startsWith("e"));

    return (
        <div data-testid="standings-page" className="grain">
            <section className="border-b border-line py-16 md:py-24 bg-bg-soft">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-xs tracking-[0.4em] uppercase font-bold mb-4">The Race</div>
                    <h1 className="h-display text-6xl md:text-8xl">Standings</h1>
                    <p className="text-ink text-lg mt-5 max-w-xl">2025-2026 ABA Conference standings.</p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid md:grid-cols-2 gap-8">
                <Conf title="Western" items={west} testid="west" />
                <Conf title="Eastern" items={east} testid="east" />
            </section>
        </div>
    );
}

function Conf({ title, items, testid }) {
    return (
        <div data-testid={`conf-${testid}`}>
            <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-4">{title} Conference</div>
            <div className="card-flat overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-bg-soft border-b border-line">
                        <tr>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">#</th>
                            <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Team</th>
                            <th className="text-right p-3 text-[10px] uppercase tracking-widest text-ink">W</th>
                            <th className="text-right p-3 text-[10px] uppercase tracking-widest text-ink">L</th>
                            <th className="text-right p-3 text-[10px] uppercase tracking-widest text-ink">PCT</th>
                            <th className="text-right p-3 text-[10px] uppercase tracking-widest text-ink">GB</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((s, i) => {
                            const games = (s.wins || 0) + (s.losses || 0);
                            const pct = games ? (s.wins / games) : 0;
                            const leader = items[0];
                            const lgames = (leader.wins || 0) + (leader.losses || 0);
                            const gb = leader.id === s.id ? "—" : (((leader.wins - s.wins) + (s.losses - leader.losses)) / 2).toFixed(1);
                            return (
                                <tr key={s.id} className={`border-t border-line ${s.is_self ? "bg-purple-dark/40" : ""}`} data-testid={`row-${testid}-${i}`}>
                                    <td className="p-3 h-display text-ink">{i + 1}</td>
                                    <td className="p-3">
                                        <span className={`${s.is_self ? "text-gold font-semibold" : "text-white"} flex items-center gap-2`}>
                                            {s.is_self && <Crown size={14} className="text-gold" />} {s.team_name}
                                        </span>
                                    </td>
                                    <td className="p-3 text-right h-display">{s.wins}</td>
                                    <td className="p-3 text-right h-display text-ink">{s.losses}</td>
                                    <td className="p-3 text-right">{pct.toFixed(3)}</td>
                                    <td className="p-3 text-right text-ink">{gb}</td>
                                </tr>
                            );
                        })}
                        {items.length === 0 && (
                            <tr><td colSpan={6} className="p-8 text-center text-ink">No standings yet.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
